/* eslint-disable import/extensions */
import * as Sentry from '@sentry/browser';
import viExtracted from './vi/extracted.json';

/**
 * Helper translations() — sync, trả text theo lang hiện tại.
 *
 * i18n code-split: KHÔNG import ./vi hay ./en (index kéo cả locations + flattenKeys
 * vào main). Chỉ dùng vi/extracted.json (bản dịch VI thô, đủ cho message text).
 * - VI: viExtracted[id] → thiếu thì fallback defaultMessage (dm inline cũng = VI).
 * - EN: en tải DYNAMIC (ensureEnTranslations) khi lang=en → điền enMessages runtime;
 *   chưa load/thiếu key → fallback defaultMessage.
 *
 * locations (form địa chỉ) đọc trực tiếp từ translations vi/en locations, không qua helper.
 */
let enMessages = {};

export const ensureEnTranslations = () => {
  if (Object.keys(enMessages).length > 0) return Promise.resolve();
  return import(/* webpackChunkName: "i18n-en" */ './en/extracted.json').then((mod) => {
    enMessages = mod.default || mod;
  });
};

export default function (message) {
  if (!message) {
    return '';
  }
  try {
    let lang = 'vi';
    if (typeof window !== 'undefined' && !!window.localStorage.getItem('lang')) {
      lang = window.localStorage.getItem('lang');
    }
    const dict = lang === 'en' ? enMessages : viExtracted;
    const translatedMessage = (dict && dict[message.id]) || message.defaultMessage;
    return translatedMessage;
  } catch (error) {
    console.error(error);
    console.log(message);
    Sentry.withScope((scope) => {
      scope.setExtra('message', message);
      Sentry.captureException(error);
    });
    return message.defaultMessage || '';
  }
}
